import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {sendInput} from 'game/app/actions/game-instance-actions';
import GameComponent from 'game/app/components/game/game-component';
import {push} from "react-router-redux";
import {Link} from "react-router-dom";
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from "reactstrap";
import assets from 'game/app/assets';

class Finalize extends GameComponent {

    constructor(params) {
        super(params);
        this.state = {
            modalOpened: false
        }
    }

    toggleModal() {
        this.setState({...this.state, modalOpened: !this.state.modalOpened})
    }

    finalize = () => {
        this.props.sendInput(this.getInstanceId(), { type: 'finalize' }).then(() => {
            push('/')
        });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
        'event': 'round_1_finish'
        });
    };

    render() {
        let currentIndex = this.getNodeIndex(this.getCurrentNodeType());
        let round01index = this.getNodeIndex('Nodes::Round01Node');
        let basic_complete = this.getInstanceProperty('ROUND_1_COMPLETED_BASIC');
        let money_enough = this.getInstanceProperty('STATS_MONEY') >= 45000;

        let unansweredCreativeTasks = this.props.creativeTasks.list.filter((task) => task.node === 'Nodes::Round01Node' && task.submissions.length === 0).length > 0;

        if (currentIndex <= round01index) {
            return (
                <div className='container'>
                    <div className='row'>
                        <div className={this.mainContainerClass}>
                            <div className='text-center'>
                                <h1>Ukončit kolo</h1>
                                <p><strong>Abyste mohli toto kolo uzavřít, musí vám v rozpočtu zbývat alespoň 45 000 Kč.</strong></p>
                                { !money_enough && <p className='text-danger'><strong>Váš rozpočet je nižší než 45 000 Kč!</strong></p> }
                                <p>Pokud máte vše v tomto kole hotové, můžete ho ukončit a pustit se do dalšího. Po ukončení tohoto kola se již nebudete moci vrátit ani ke kreativním úkolům.</p>
                                { basic_complete && money_enough && <button className='btn btn-primary' onClick={() => {
                                    if (unansweredCreativeTasks) {
                                        this.toggleModal();
                                    } else {
                                        this.finalize();
                                    }
                                }}>Ukončit kolo</button> }
                                { ( !basic_complete || !money_enough ) && <span className='btn btn-outline-primary disabled'>Ukončit kolo</span> }
                            </div>
                            <Modal isOpen={this.state.modalOpened} modalTransition={{ timeout: 200 }} backdropTransition={{ timeout: 200 }} className={this.props.className}>
                                <ModalHeader toggle={() => { this.toggleModal(); }}>Máte kreativní úkol?</ModalHeader>
                                <ModalBody>
                                    <p>Odevzdali jste kreativní úkol? Po ukončení kola ho již nemůžete ani nahrát ani změnit.</p>
                                </ModalBody>
                                <ModalFooter>
                                    <Link to={`/game/${this.getInstanceId()}/round-1/otazky`} className="btn btn-success">Vrátit se k úkolu</Link> <Button color="secondary" onClick={this.finalize}>Ukončit kolo</Button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    </div>
                </div>
            )
        } else {

            let chechtakyTotal = this.getInstanceProperty('ROUND_1_CHECHTAKY');
            let chechtakyTasks = this.getInstanceProperty('ROUND_1_CHECHTAKY_TASKS');
            let chechtakyAnswers = this.getInstanceProperty('ROUND_1_CHECHTAKY_ANSWERS');
            let satisfactionTotal = this.getInstanceProperty('ROUND_1_SATISFACTION');
            let financialIndex = this.getInstanceProperty('ROUND_1_FINANCIAL_INDEX');

            return (
                <div className='container'>
                    <div className='row'>
                        <div className={this.mainContainerClass}>
                            <h1 className='page-title-minor separate-bottom'>Vyhodnocení 1. kola</h1>
                            <div className='card' id='round-result'>
                                <div className='card-body text-center'>
                                    <div className='row'>
                                        <div className='col-lg-4'>
                                            <p><img src={assets.resources.chechtaky}/></p>
                                            <p className='label'>Chechtáky</p>
                                        </div>
                                        <div className='col-lg-4'>
                                            <table className='table text-left'>
                                                <tbody>
                                                    <tr><td>Ukončení kola:</td><td className='text-right'>{ this.numberWithSign(10) }</td></tr>
                                                    <tr><td>Volba rodiny a úkoly:</td><td className='text-right'>{ this.numberWithSign(chechtakyAnswers) }</td></tr>
                                                    <tr><td>Kreativní úkoly:</td><td className='text-right'>{ this.numberWithSign(chechtakyTasks) }</td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className='col-lg-4'>
                                            <span className='value'>{ this.numberWithSign(chechtakyTotal) }</span>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className='row'>
                                        <div className='col-lg-4'>
                                            <p><img src={assets.resources.satisfaction_small}/></p>
                                            <p className='label'>Spokojenost</p>
                                        </div>
                                        <div className='col-lg-4'/>
                                        <div className='col-lg-4 col-lg-push-4'>
                                            <span className='value'>{ this.numberWithSign(satisfactionTotal) }</span>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className='row'>
                                        <div className='col-lg-4'>
                                            <p><img src={assets.finindex}/></p>
                                            <p className='label'>Finanční index</p>
                                        </div>
                                        <div className='col-lg-4'/>
                                        <div className='col-lg-4'>
                                            <span className='value'>{ financialIndex.toFixed(2) }</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row text-center separate-bottom aligned-lg'>
                                <div className='col-lg-4'>
                                    <div className='card aligned-card'>
                                        <div className='card-body'>
                                            <img src={assets.bydleni} className='img-fluid'/>
                                            <h5>Bydlení</h5>
                                            <p>{ this.getHousing().result }</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-4'>
                                    <div className='card aligned-card'>
                                        <div className='card-body'>
                                            <img src={assets.jidlo} className='img-fluid'/>
                                            <h5>Jídlo</h5>
                                            <p>{ this.getFood().result }</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-4'>
                                    <div className='card aligned-card'>
                                        <div className='card-body'>
                                            <img src={assets.doprava} className='img-fluid'/>
                                            <h5>Doprava</h5>
                                            <p>{ this.getTransportation().result }</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='text-center'>
                                <Link to={`/game/${this.getInstanceId()}/round-2`} className='btn btn-primary btn-block'>Pokračovat do druhého kola</Link>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        gameInstance: state.gameInstance,
        creativeTasks: state.creativeTasks
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        sendInput: sendInput,
        push: push
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Finalize);
